// extracted by mini-css-extract-plugin
export default {"button_area":"Epjyxz7UGqwWNET9oGyZ"};